import { FC } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { twMerge } from 'tailwind-merge';
import { SeverityType, severityTypeToColor } from '@/services/warnings/warningDefinitions';

interface Props {
  severity: SeverityType;
  className?: string;
}

export const WarningSymbol: FC<Props> = ({ severity, className }) => {
  const color = severityTypeToColor(severity);
  return <FiAlertTriangle className={twMerge(className)} color={color} />;
};
